import { useState, useCallback, useMemo, createElement } from "react";
import PropTypes from "prop-types";
import { unset, set } from "lodash/fp";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import { toastContext } from "../../contexts/toast-context/toast-context.es.js";
const { Provider } = toastContext;
const propTypes = {
  children: PropTypes.node.isRequired
};
const ToastProvider = ({ children }) => {
  const [toastMap, setToastMap] = useState({});
  const removeToast = useCallback((toasterId, toastId) => {
    setToastMap(unset([toasterId, toastId]));
  }, []);
  const setToast = useCallback(
    (toasterId, toastId, { clickable, onDismiss, message, variant }) => {
      setToastMap(
        set([toasterId, toastId], {
          clickable,
          onDismiss,
          id: toastId,
          message,
          variant
        })
      );
    },
    []
  );
  const contextValue = useMemo(
    () => ({
      setToast,
      removeToast,
      toastMap
    }),
    [setToast, removeToast, toastMap]
  );
  return createElement(Provider, { value: contextValue }, children);
};
ToastProvider.propTypes = propTypes;
export {
  ToastProvider
};
